import { render, staticRenderFns } from "@/clickbuy/convocation/views/convocation-list/convocation-list.pug?vue&type=template&id=41f2f129&scoped=true&lang=pug&external"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "@/clickbuy/convocation/views/convocation-list/convocation-list.scss?vue&type=style&index=0&id=41f2f129&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f2f129",
  null
  
)

export default component.exports